import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'suka-tab',
  template: `
    <div [hidden]="!active" class="tabs__tab-item">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabItem implements OnChanges {
  @Input() title: string;

  @Input() active = false;

  @Output() selected = new EventEmitter<string>();

  public ngOnChanges(): void {
    if (this.active === true) {
      this.selected.emit(this.title);
    }
  }
}
